export default __webpack_public_path__ + "static/media/robot-api.db6181bc.png";